var globals = require("./modules/globals");
var utils = require("./modules/utils.js");
var preprocess = require("./modules/preprocess.js");
var graph = require("./modules/graph.js");
var handlers = require("./handlers.js");
var analyse = require ("./modules/analyse.js")
var timeline = require("./timeline.js"); 
var router = require("./router.js");


var yearSize = 70;
var monthSize = yearSize /12;
var daySize = yearSize / 360;
var eventTypes = {};
var eventTypesData = []
var dates = {};
var datesData = [];
var minYear = 1900;
var leftMargin = 200;
var linksData = []; 
var nodesData = [];
var protagonists = {M: 'Manquilef', AP: 'Arurto Panguileft', C: 'Conuepan'}
 
 
var allDates = [];
var locations = [];
var venues = [];
var professions = ['[select]'];
var allPeople = [];
var allEvents = [];
var relationships = ['[select]'];
var parties = []
var birthplaces = [];

var currentCats = [];
 
i = 0
while (i<70) {
    allDates.push(minYear + i)
    i = i + 1;
}
 
var yAxis = {}


d3.json("data/data.json", function(error, __data) {
    
    console.log(__data);
    if (error) throw error;
    windowHeight = window.innerHeight;
    unit = (windowHeight - 100) / 6;
    yAxis = {"M":{yVal:unit + 50}, "AP":{yVal:unit*3},"C":{yVal:(unit*5) -50}};
    globals.yAxis = {"M":{yVal:unit + 50}, "AP":{yVal:unit*3},"C":{yVal:(unit*5) -50}};
    globals._data.master = __data;
    // Extra data formatting, could pos be done in tabletop_processor 
  
    graph.createTimescale(__data.events);      
 
    __data = preprocess.prep(__data);
    router.init(__data)
//    timeline.init(__data, window.innerHeight) 
/*    __data.events.forEach(function(d) {
	allEvents.push(d.eventName)
	if(utils.checkExists(d.location, locations, 'none') == false) {
	    locations.push(d.location)
	}
	
	if(utils.checkExists(d.venue, venues, 'none') == false) {
	    venues.push(d.venue)
	}
	
	checkTypes(d.eventType);
	d.type = 'event';
	if(d.startDate !='') {
	    d.ongoing = true;
	    base = dateToX(d.startDate);
	    halfLen = (dateToX(d.endDate) - dateToX(d.startDate)) / 2
	    d.x = (base + halfLen);
	    d.fx = d.x;
	} else {
	    d.ongoing = false;
	    d.x =  dateToX(d.date);
	    d.fx = d.x;
	}

	if(d.datasets.length > 1) {
	    total = 0;
	    for(data in d.datasets) {
		total = total + yAxis[d.datasets[data]].yVal;
	    }
	    d.y = total / d.datasets.length;
	} else {
	    d.y = yAxis[d.datasets[0]].yVal;
	}

	if(d.startDate != '') {
	    d.y = d.y + ((dateToX(d.endDate) - dateToX(d.startDate)) / 15);
	}
 	
    });

    __data.people.forEach(function(d) {
	allPeople.push(d.name)
//	console.log(checkExists(d.proffesion, professions, 'none'))
	if(utils.checkExists(d.proffesion, professions, 'none') == false) {
	    professions.push(d.proffesion);
	}
	if(utils.checkExists(d.relProtagonist, relationships, 'none') == false) {
	    relationships.push(d.relProtagonist)
	}
	if(utils.checkExists(d.party, parties, 'none') == false) {
	    parties.push(d.party)
	}
	if(utils.checkExists(d.residence, birthplaces, 'none') == false) {
	    birthplaces.push(d.residence)
	}
	
    })
*/
    settingsData = {
	dateOptions: __data.allDates,
	relOptions: __data.relationships,
	professionOptions: __data.professions,
	partyOptions: __data.parties,
	copy: __data.copy,
    }

    $.ajax({
        url:'templates/search.html',
        cache:false,
    }).done(function(data) {
        $('#timeline-container').append(Mustache.render(data, settingsData));
        $('#personSearch').autocomplete({
            source: __data.peopleList,
        });
        $('#eventSearch').autocomplete({
            source: __data.eventList,
        });
        $("#eventSearchSubmit").click(function() {
            $(".selected").removeClass("selected");
            val = $("#eventSearch").val();
            analyse.find(val, 'events');
            $(".search-page-container").fadeOut();
        });

        $("#personSearchSubmit").click(function() {
            $(".selected").removeClass("selected");
            val = $("#personSearch").val();
            pID = analyse.find(val, 'people');
            if(pID){
            	timeline.updateNetwork()
                d3.select("circle#"+pID)
                    .attr("class", "selected");
            	setTimeout(function() {
                    utils.scrollTo(pID);
                },400)
			}
            $(".search-page-container").fadeOut();
        });

        $(".close-button").click(function() {
        	$(this).parent().fadeOut();
		})
    });

    $.ajax({
        url:'templates/list.html',
        cache:false,
    }).done(function(data) {
    	obj = {
    		people: globals._data.master.people.sort(function(a, b){
                if(a.name < b.name) { return -1; }
                if(a.name > b.name) { return 1; }
                return 0;
            }),
			events: globals._data.master.events.sort(function(a, b){
                if(a.eventName < b.eventName) { return -1; }
                if(a.eventName > b.eventName) { return 1; }
                return 0;
            }),
			copy: globals.copy,
		}
        $('#timeline-container').append(Mustache.render(data, obj));

    	$(".list-item").click(function() {
            $(".selected").removeClass("selected");
            val = $(this).text();
            if($(this).hasClass("person")) {
                pID = analyse.find(val, 'people');
                if(pID){
                    timeline.updateNetwork()
                    d3.select("circle#"+pID)
                        .attr("class", "selected");
                    setTimeout(function() {
                        utils.scrollTo(pID);
                    },400)
                }
            } else {
                analyse.find(val, 'events');
            }
            $(".list-page-container").fadeOut();
        });


        $(".close-button").click(function() {
            $(this).parent().fadeOut();
        })

    });

    $("#list").click(function() {
    	$(".list-page-container").fadeIn();
	})

    $("#search").click(function() {
        $(".search-page-container").fadeIn();
	})

	var allPeopleAwake = false;
    var allPeople = true;

    $("#showAllPeople").click(function() {
        //	    showAllPeople();
		if(allPeopleAwake) {
            /*console.log(globals._data.nodesData)
			globals._data.nodesData = globals._data.master.events;
            globals._data.nodesData.forEach(function(d, i){
				if(d.type === 'person') {
					globals._data.nodesData.splice(i, 1)
				}
			})
            console.log(globals._data.nodesData)
            globals._data.linksData = [];*/
            if(allPeople) {
                d3.select("g.people").transition()
                    .style("display", "none")

                d3.select("g.links").transition()
                    .style("display", "none")
				allPeople = false;
            } else {
                d3.select("g.people").transition()
                    .style("display", "block")

                d3.select("g.links").transition()
                    .style("display", "block")
				allPeople = true;
			}

		} else {
            globals._data.nodesData.forEach(function (d) {
                if (d.type == 'event') {
                    el = analyse.findAttendees(d.id, globals._data);
                    globals._data.nodesData = globals._data.nodesData.concat(el.newPeople)
                    globals._data.linksData = globals._data.linksData.concat(el.newLinks);
                }
            });
            allPeopleAwake = true;
        }

        timeline.updateNetwork();
    });



	var instructionNo = 0;

    instructionTemplate = "<h3>{{title}}</h3><br/>\n" +
        "        <p>{{text}}</p>\n" +
        "        <div class=\"instruction-next\">{{copy.next}}>></div>\n" +
        "        <div class=\"instruction-skip\">{{copy.skip}}</div>"

    instructions = [
		{
			title: globals.copy.instruction1title,
			text:  globals.copy.instruction1text,
			top: "35%",
			left: "50%",
			copy: globals.copy
		},
		{
			title: globals.copy.instruction2title,
			text: globals.copy.instruction2text,
			top: "40%",
			left: "15%",
		},
		{
            title: globals.copy.instruction3title,
            text: globals.copy.instruction3text,
            top: "10%",
            left: "80%",
		},
        {
            title: globals.copy.instruction4title,
            text: globals.copy.instruction4text,
            top: "25%",
            left: "80%",
        },
        {
            title: globals.copy.instruction5title,
            text: globals.copy.instruction5text,
            top: "15%",
            left: "50%",
        },
	]

	function initInstructions() {

    	instructionNo = 0;

        $(".instruction-container").html(Mustache.render(instructionTemplate, instructions[instructionNo])).css('top', instructions[instructionNo].top).css('left', instructions[instructionNo].left)

        $(".instruction-skip").click(function () {
            $(this).parent().fadeOut();
        })

        $(".instruction-next").click(function () {
        	if(instructionNo === instructions.length -1) {
                $(this).parent().fadeOut();
			} else {
                instructionNo = instructionNo + 1;
                $(this).parent().fadeOut(function () {
                    $(this).find("h3").html(instructions[instructionNo].title)
                    $(this).find("p").html(instructions[instructionNo].text)
                    $(this).css("top", instructions[instructionNo].top)
                    $(this).css("left", instructions[instructionNo].left)
                    $(this).fadeIn();
                })
            }
        })

		$(".instruction-container").fadeIn();
    }

    initInstructions()

	$("#help").click(function() {
		initInstructions();
	})

	$(".back-to-timline-txt").text(globals.copy.backTo)
	$("#list").text(globals.copy.list)
	$("#help").text(globals.copy.help)



 /*   $.ajax({
	url:'templates/settings.html',
	cache:false,
    }).done(function(data) {
	$('#timeline-container').append(Mustache.render(data, settingsData));
	$(".settings-title").click(function() {
	    $(this).parent().toggleClass("expanded");
	})
	$('#personSearch, #personASelect, #personBSelect').autocomplete({
	    source: __data.peopleList,
	});
	$('#eventSearch').autocomplete({
	    source: __data.eventList,
	});
	$('#locationFilter').autocomplete({
	    source: __data.locations,
	});
	$('#venueFilter').autocomplete({
	    source: __data.venues,
	});
	$('#birthFilter').autocomplete({ 
	    source: __data.birthplaces,
	});

	$("#eventSearchSubmit").click(function() {
	    $(".selected").removeClass("selected");
	    val = $("#eventSearch").val();
	    analyse.find(val, 'events');
	});

	$("#personSearchSubmit").click(function() {
	    $(".selected").removeClass("selected");
	    val = $("#personSearch").val();
	    analyse.find(val, 'people');
	});
	
	$("#eventFilterSubmit").click(function() {
//	    timeline.fixEvents()
//	    analyse.filterEvents(currentCats);
	    timeline.updateEvents();
	});

	$("#personFilterSubmit").click(function() {
	    analyse.filterPeople();
	    timeline.updateNetwork();
	})

	$("#connectionsSubmit").click(function() {
	    pA = $("#personASelect").val();
	    pB = $("#personBSelect").val();
	    analyse.findConnections(pA, pB);
	    timeline.updateEvents()
	    timeline.updateNetwork()
	});
	
	$("#showAllPeople").click(function() {
	    //	    showAllPeople();
	    console.log("showppl")
	    globals._data.nodesData.forEach(function(d) {
		if(d.type == 'event') {
		    el = analyse.findAttendees(d.id, globals._data);
		    globals._data.nodesData = globals._data.nodesData.concat(el.newPeople)
		    globals._data.linksData = globals._data.linksData.concat(el.newLinks);
		}
	    });
	    
	    timeline.updateNetwork();
	});

	$("#analyseNetwork").click(function() {
	    $(".analyse-container").remove();
	    analyseData = analyse.analyseAll();
	    $.ajax({
		url:'templates/analyse.html',
		cache:false,
	    }).done(function(data) {
		$('#timeline-container').append(Mustache.render(data, analyseData));
		$(".analyse-container .close-btn").click(function() {
		    $(this).parent().fadeOut();
		});
		$(".collapse-section").click(function() {
		    $(this).toggleClass("expanded");
		})
	    });
	});

	$("#resetAll").click(function() {
	    $("#locationFilter").val("");
	    $("#venueFilter").val("");
	    $("#professionFilter").val("");
	    $("#partyFilter").val("");
	    $("#birthFilter").val("");
	    $("#relFilter").val("");
	    $("#maleFilter").prop('checked',true);
	    $("#femaleFilter").prop('checked',true);
	    $(".name-label").addClass("active");
	    //	    timeline.updateEvents();
	    timeline.resetCategories();
	    globals._data.nodesData = globals._data.nodesData.filter(function(d) { return d.type == 'event';} );
	    globals._data.linksData = [];
	    timeline.updateNetwork();
	});
	
	$(".close-btn").click(function() {
	    $(this).parent().parent().fadeOut();
	});
    });

*/

    $(".name-label").click(function() {
	$(this).toggleClass("active");
	timeline.updateEvents();
    });
    
//    console.log(venues)
//    console.log(eventTypesData)
 //   orderDates();

//    assignColorVals();

    for(type in __data.eventTypes) {
//	eventTypes[type].title = type;
//	eventTypes[type].active = false;
	currentCats.push({title: type, active:true});
//	eventTypesData.push(eventTypes[type])
    }

    console.log(currentCats)   

    // Set up basic variables and svg layers
    
/*    var svg = d3.select("svg#timeline"),
	width = +svg.node().getBoundingClientRect().width,
	height = +svg.node().getBoundingClientRect().height;

    var color = d3.scaleLinear()
	.domain([0, 0.4, 1.1])
	.range(["rgb(64, 10, 255)", "rgb(255, 12, 228)", "rgb(255, 181, 0)"]);  
 
    
    var simulation = d3.forceSimulation()
	.force("collide", d3.forceCollide(5).iterations(20))
	.force("charge", d3.forceManyBody().strength(-5))
	.force("link", d3.forceLink().id(function(d) { return d.id; }))

    var networkSimulation = d3.forceSimulation()
	.force("link", d3.forceLink().id(function(d) { return d.id; }))
	.force("charge", d3.forceManyBody())
	.force("collide", d3.forceCollide(5).iterations(20))
    
    var eventsLayer = svg.append("g")
	.attr("class", "events")

//    var nodesData = [];
//    var linksData = [];
    
    var linksLayer = svg.append("g")
	.attr("class", "links");

    var nodesLayer = svg.append("g")
	.attr("class", "people");

    var timeScaleLayer = svg.append("g")
//    	.data(datesData)
//	.enter().append("g")
	.attr("class", "timeScale")

    var categoriesLayer = svg.append("g")
	.attr("class", "categories");

    var categoriesScale = d3.scaleOrdinal([0, __data.eventTypes[__data.eventTypes.length -1]])
    var catWidth = 120
        
    
    var categories = categoriesLayer.selectAll("text")
	.data(__data.eventTypes)
	.enter().append("text") 
	.text(function(d) { return "#" + d.title; })
	.attr("y", 75)		  
	.attr("x", 0)
	.attr("font-size", 20)
	.attr("fill", function(d) { return globals.units.color(d.color); })
	.attr("transform", function(d, i) { return "translate("  + (i+1) * catWidth  + ",0)"; })
	.attr("opacity", 0.6)
	.on("click", updateCategories)
	      

    var nodes = nodesLayer.selectAll("circle")
	  .data(nodesData)
	  .enter().append("circle")
	  .attr("r", 5)
	  .attr("fill", "white")
	  .attr("opacity", 0.7);

	
    var links = linksLayer.selectAll("line")
	    .data(linksData)
	    .enter().append("line")
	    .attr("stroke-width", 1)
	    .attr("stroke", "white")
	    .attr("opacity", 0.3);

    nodesData = __data.events;
    globals._data.nodesData = __data.events;
    
    var events = eventsLayer.selectAll("ellipse")
	.data(nodesData.filter(function(d) { return d.type =='event';}))
	.enter().append("ellipse")
	.attr("ry", function(d) { return 7 * d.datasets.length; })
	.attr("rx", function(d) { return graph.getRx(d.startDate, d.endDate, d.datasets); })
	.attr("fill", function(d) { return color(__data.eventTypes.filter(function(e) { return e.title == d.eventType;})[0].color); })
	.attr("cx", function(d) { return d.x; })
	.attr("cy", function(d) { return d.y; })
	.attr("opacity", function(d) { return graph.getOpacity(d.ongoing);})
	.on("click", handlers.eventClick);
    
    events.append("title")
      .text(function(d) { return d.eventName; });

    var timeScale = timeScaleLayer.selectAll("text")
	.data(globals._data.datesData)
	.enter().append("text")
	.attr("x", function(d) { return d.x + 5; })
	.attr("y", windowHeight - 30)
	.attr("fill", "white")
	.attr("font-size", "12px")
	.attr("opacity", 0.9)
	.text(function(d) { return d.year;});

    var notches = timeScaleLayer.selectAll("line")
	.data(globals._data.datesData)
	.enter().append("line")
	.attr("x1", function(d) { return d.x; })
	.attr("y1", windowHeight - 25)
	.attr("x2", function(d) { return d.x; })
	.attr("y2", function(d) { return d.timebreak ? 50 : windowHeight - 40; })
	.attr("stroke-width", 1)
	.attr("stroke", "white")
	.style("stroke-dasharray", function(d) { return d.timebreak ? "3, 7" : "3, 0"; })
	.attr("opacity", function(d) { return d.timebreak ? 0.57 : 0.8; })

    var timeBaseLine = svg.append("line")
	.attr("x1", globals._data.datesData[0].x)
	.attr("x2", globals._data.datesData[globals._data.datesData.length -1].x)
	.attr("y1", windowHeight - 25)
	.attr("y2", windowHeight - 25)
	.attr("stroke-width", 1)
	.attr("stroke", "white")
	.attr("opacity", 0.8)
    
    simulation
	.nodes(nodesData)
	.on("tick", ticked);

  */ 
    $("#settings-icon").click(function() {
	$(".settings-container").fadeIn();
    })
     
    /*
    function ticked2() {
  
	events
            .attr("cx", function(d) { return d.x; })
            .attr("cy", function(d) { return d.y; });

    }

    function ticked() {
	events
            .attr("cx", function(d) { return d.x; })
            .attr("cy", function(d) { return d.y; });
	
	links
            .attr("x1", function(d) { return d.source.x; })
            .attr("y1", function(d) { return d.source.y; })
            .attr("x2", function(d) { return d.target.x; })
            .attr("y2", function(d) { return d.target.y; });

	nodes
            .attr("cx", function(d) { return d.x; })
            .attr("cy", function(d) { return d.y; });
    }
    */
/*    function eventClick(d) {
	
	if(d.startDate != '') {
	    eventDate = d.startDate + " to " + d.endDate;
	} else {
	    eventDate = d.date;
	}

	$(".info-container").remove();
	
	eventData = {
	    name: d.eventName,
	    image: d.image,
	    venue: d.venue,
	    location: d.location,
	    notes: d.notes,
	    category: d.eventType,
	    pSource: d.pSource,
	    sSource: d.sSource,
	    date: eventDate,
	    color:color(eventTypes[d.eventType].color),
	    id:d.id
	}


	if(d.x > 555) {
	    eventX = d.x - 550
	} else {
	    eventX = d.x + 50;
	}
	
	if(d.y > 300) {
	    eventY = d.y - 250;
	} else {
	    eventY = d.y + 50;
	};
	
	$.ajax({
	    url:'templates/eventInfo.html',
	    cache:false,
	}).done(function(data) {
	    $('body').append(Mustache.render(data, eventData));
	    $(".info-container").css("left", eventX+"px").css("top", eventY+"px")
	    $(".info-container").fadeIn();
	    $(".close-btn").click(function() {
		$(this).parent().parent().fadeOut(500, function() { $(this).remove() });
	    });
	    $(".action-btn").click(function() {
		showAttendees($(this).parent().parent().attr("data-eventid"));
	    });
	});
    }
*/
/*    function personClick(d) {
	$(".info-container").remove();
	if(d.x > 555) {
	    eventX = d.x - 550
	} else {
	    eventX = d.x + 50;
	}
	
	if(d.y > 300) {
	    eventY = d.y - 250;
	} else {
	    eventY = d.y + 50;
	};

	if(d.relProtagonist == '') {
	    d.relProtagonist = 'unkown relation';
	} 
	 
	console.log(d)
	person = {
	    id: d.id,
	    name: d.name,
	    relationship: d.relProtagonist,
	    protagonist: protagonists[d.datasets[0]] + "'s ",
	    residence: d.residence,
	    bio: d.bioEn,
	    party: d.party,
	    proffesion: d.proffesion,
	}
	
	$.ajax({
	    url:'templates/personInfo.html',
	    cache:false,
	}).done(function(data) {
	    $('body').append(Mustache.render(data, person));
	    $(".info-container").css("left", eventX+"px").css("top", eventY+"px")
	    $(".info-container").fadeIn();
	    $(".close-btn").click(function() {
		$(this).parent().parent().fadeOut(500, function() { $(this).remove() });
	    });
	    $(".action-btn").click(function() {
		showAttendees($(this).parent().parent().attr("data-eventid"));
	    });
	}); 
    }
  */    
    function showAttendees(event) {
	newLinks = __data.links.filter( function(l) { return l.target == event;})
	linksData = linksData.concat(newLinks);
	currentPeople = nodesData.filter( function(d) { return d.type == 'person'; });
	for(dd in newLinks) {
	    if(utils.checkExists(newLinks[dd].source, currentPeople, 'id') == false) {
		person = __data.people.filter( function(p) { return p.id == newLinks[dd].source; })[0];
		person.type = 'person';
		nodesData.push(person);
		currentPeople.push(person);
	    }
	};
 
	nodesData.filter(function(d) { return d.type == 'event'; }).forEach(function(e) {
	    e.fy = e.y;
	})

	updateNetwork()
    }

    function showAllPeople() {
	nodesData.forEach(function(d) {
	    if(d.type == 'event') {
		showAttendees(d.id)  
	    }
	});
    }
    
    function updateNetwork() {
	
	simulation.force("charge").strength(-30);
	
	nodes = nodes.data(nodesData.filter(function(d) { return d.type == 'person'; }))
	nodes.exit().remove()
	nodes = nodes.enter().append("circle")
	    .attr("r", 5)
	    .attr("fill", "rgb(150,200,229)")
	    .attr("opacity", 0.9)
	    .on("click", handlers.personClick)
	    .merge(nodes);

	nodes.append("title")
	    .text(function(d) { return d.name; });
	
	links = links.data(linksData)
	links.exit().remove()
	links = links.enter().append("line")
	    .attr("stroke-width", 1)
	    .attr("stroke", "white")
	    .attr("opacity", 0.3)
	    .merge(links);

	simulation
	    .nodes(nodesData);

	simulation.force("link")
	    .links(linksData);
	
	simulation.alpha(1).restart()
    }

    function updateCategories(d) {
	d.active = d.active ? false : true;
	
	categories
	    .attr("opacity", function(d) { return d.active ? 0.8 : 0.5; })
	    .attr("text-decoration", function(d) { return d.active ? "underline" : "none";})
	
	currentCats = []
	__data.eventTypes.forEach(function(d) {
	    if(d.active == true) {
		currentCats.push(d)
	    }
	});
	
	filterEvents();

    }

    function filterEvents() {
	nodesData.filter(function(d) { return d.type == 'event'; }).forEach(function(e) {
	    e.fy = e.y;
	})
	people = nodesData.filter(function(d) { return d.type == 'person'; })
	
	var startDateFilter = $("#startDateFilter").find(":selected").text();
	var endDateFilter = $("#endDateFilter").find(":selected").text();

	newEvents = __data.events.filter(function(d) {
	    type = d.eventType
	    add = false;
	    if(d.startDate !='' && d.endDate !='') {
		start = utils.formatDate(d.startDate);
		end = utils.formatDate(d.endDate);
		if((start <= startDateFilter && end >= endDateFilter) || (end >= startDateFilter && end <= endDateFilter) || (start >= startDateFilter && start <= endDateFilter)) {
		    currentCats.forEach(function(c) {
			if(type == c.title) {
			    add = true;
			}
		    })   
		}
	    } else if(d.date != '') {
		if(utils.formatDate(d.date) >= startDateFilter && utils.formatDate(d.date) <= endDateFilter) {
		    currentCats.forEach(function(c) {
			if(type == c.title) {
			    add = true;
			}
		    })
		}
	    }

	    if(add == true) {
		return d;
	    } 
	}); 

	var location = $("#locationFilter").val();

	if(location != '') {
	    newEvents = newEvents.filter(function(d) { return d.location == location; });
	}

	venue = $("#venueFilter").val();
	if(venue != '') {
	    newEvents = newEvents.filter(function(d) { return d.venue == venue});
	}
	
	nodesData = people.concat(newEvents);
    
	if(linksData.length > 0) {
	    el = graph.removeUnlinkedPeople(nodesData, linksData);
	    linksData = el.links;
	    nodesData = el.nodes;
	}
	
//	console.log(nodesData)
//	console.log(linksData)
	updateEvents();
    }
    
    function updateEvents() {
	
	simulation.force("charge").strength(-5);
	
	events = events.data(nodesData.filter(function(d) { return d.type == 'event';}))
	events.exit().remove()
	
	graph.createTimescale(nodesData.filter(function(d) { return d.type == 'event';}))
	updateTimeScale();
	
	events
	    .attr("ry", function(d) { return 7 * d.datasets.length; })
	    .attr("rx", function(d) { return graph.getRx(d.startDate, d.endDate, d.datasets); })
	    .attr("cx", function(d) { return graph.getX(d); })
	    .attr("cy", function(d) { return graph.getY(d.startDate, d.endDate, d.datasets); })
	    .attr("fill", function(d) { return globals.units.color(__data.eventTypes.filter(function(e) { return e.title == d.eventType;})[0].color); })
	    .attr("opacity", function(d) { return graph.getOpacity(d.ongoing); })
	    .on("click", handlers.eventClick) 

	events = events.enter().append("ellipse")
	    .attr("ry", function(d) { return 7 * d.datasets.length; })
	    .attr("rx", function(d) { return graph.getRx(d.startDate, d.endDate, d.datasets); })
	    .attr("cx", function(d) { return graph.getX(d); })
	    .attr("cy", function(d) { return graph.getY(d.startDate, d.endDate, d.datasets); })
	    .attr("fill", function(d) { return globals.units.color(__data.eventTypes.filter(function(e) { return e.title == d.eventType;})[0].color); })
	    .attr("opacity", function(d) { return graph.getOpacity(d.ongoing); })
	    .on("click", handlers.eventClick) 
	    .merge(events);
	
	events.select("title")
	    .text(function(d) { return d.eventName; });
		 
	simulation
	    .nodes(nodesData);
	
	simulation.force("link")
	    .links(linksData);
	
	simulation.alpha(0.3).restart()

	updateNetwork();

    };

    function updateTimeScale() {
//	console.log(datesData)
	timeScale = timeScale.data(globals._data.datesData)
	timeScale.exit().remove()
	timeScale.text(function(d) { return d.year; })
	timeScale = timeScale.enter().append("text")
	    .attr("x", function(d) { return d.x + 5; })
	    .attr("y", 950)
	    .attr("fill", "white")
	    .attr("font-size", "12px")
	    .attr("opacity", 0.9)
	    .text(function(d) { return d.year;})
	    .merge(timeScale)

	notches = notches.data(globals._data.datesData)
	notches.exit().remove()
	notches
	    .attr("y2", function(d) { return d.timebreak ? 50 : 940; })
	    .style("stroke-dasharray", function(d) { return d.timebreak ? "3, 7" : "3, 0"; })
	    .attr("opacity", function(d) { return d.timebreak ? 0.57 : 0.8; })

	notches = notches.enter().append("line")
	    .attr("x1", function(d) { return d.x; })
	    .attr("y1", 955)
	    .attr("x2", function(d) { return d.x; })
	    .attr("y2", function(d) { return d.timebreak ? 50 : 940; })
/*		if(d.timebreak == true) {
		    return 50;
		} else {
		    return 940;
		}
	    })*/
	    .attr("stroke-width", 1)
	    .attr("stroke", "white")
	    .style("stroke-dasharray", function(d) { return d.timebreak ? "3, 7" : "3, 0"; })
/*		if(d.timebreak == true) {
		    return ("3, 7")
		} else {
		    return ("3, 0")
		}
	    })*/
	    .attr("opacity", function(d) { return d.timebreak ? 0.57 : 0.8;})
/*		if(d.timebreak == true) {
		return 0.57
		} else {
		    return 0.8
		}
	    })*/
	    .merge(notches)
	
	timeBaseLine
	    .attr("x1", globals._data.datesData[0].x)
	    .attr("x2", globals._data.datesData[globals._data.datesData.length -1].x)
    }
});



/*function formatDate(date) {
    if(date != '') {
	sections = date.split('/')
	if(sections.length > 1) {
	    date = sections[2];
	} else {
	    date = sections[0];
	}
    }
    
    return date;
}*/

/*
function checkTypes(type) {
    exists = false;
    for(t in eventTypes) {
	if(eventTypes[t] == type) {
	    exists = true;
	}
    }
    if(exists === false) {
	eventTypes[type] = {color:0};
    }
}


//Is already two functions
function checkDates(date) {
    year = utils.formatDate(date) 
    if(utils.checkExists(year, datesData, 'year') == false) {
	datesData.push({ year:year, x:0, timebreak:false})
    }
}
 
function assignDateVals() {

    prevDate = datesData[0].year;
    i = 0;
    for(d in datesData) {
	datesData[d].x = leftMargin + (i * yearSize);
	if((datesData[d].year - prevDate) > 1) {
	    datesData[d].timebreak = true;
	}
	i = i +1;
	prevDate = datesData[d].year;
    }
}

var colorI = 0;

function assignColorVals() {
    for(t in eventTypes) {
	eventTypes[t].color = colorI / 10;
	colorI = colorI + 1;
    }
    
}
 
function dateToX(date) {
    sections = date.split("/");
    if(sections.length > 1) {
	xPos = (sections[0] * daySize) + (sections[1] * monthSize) + datesData.filter(function(d) { return d.year == sections[2];})[0].x;
    } else {
	xPos = datesData.filter(function(d) { return d.year == sections[0]; })[0].x;
    }
    return xPos;
}

function createTimescale(eventsdata) {
    datesData = []
    eventsdata.forEach(function(d) {
	if(d.startDate != '') {
	    checkDates(d.startDate);
	    checkDates(d.endDate);
	} else {
	    checkDates(d.date);
	}
    })
    datesData = datesData.sort(function(a, b) { return a.year - b.year; });
    assignDateVals()
    globals._data.datesData = datesData;
}*/
/*
function getRx(start,end,datasets) {
    if(start != '') {
	return ((dateToX(end) - dateToX(start)) /2) + (7* datasets.length);
    } else {
	return 7 * datasets.length;
    }
}

function getOpacity(ongoing) {
    if(d.ongoing == true) {
	return 0.4
    } else {
	return 0.5
    }
}

function getY(start, end, datasets) {
    if(datasets.length > 1) {
	total = 0;
	for(data in datasets) {
	    total = total + yAxis[datasets[data]].yVal;
	}
	y = total / datasets.length;
    } else {
	y = yAxis[datasets[0]].yVal;
    }
    
    if(start != '') {
	y = y + ((dateToX(end) - dateToX(start)) / 15);
    }
    return y
}

function getX(d) {
    if(d.startDate !='') {
	base = dateToX(d.startDate);
	halfLen = (dateToX(d.endDate) - dateToX(d.startDate)) / 2
	d.fx = base + halfLen
	return base + halfLen
	
    } else {
	d.ongoing = false;
	d.fx =  dateToX(d.date);
	return dateToX(d.date);
    }	    
};
*/

/*function checkExists(id, library, field) {
    exists = false;
    for(l in library) {
	if(field == 'source' || field == 'target') {
	    info = library[l][field].id
	} else if (field == 'none') {
	    info = library[l]
	} else {
	    info = library[l][field]
	}
	if(id == info) {
	    exists = true;
	} 
    }
    return exists;
}*/
/*
function removeUnlinkedPeople() {
    linksData = linksData.filter(function(d) {
	if(utils.checkExists(d.target.id, nodesData, 'id') == true) {
	    return d
	}
    });
    nodesData = nodesData.filter(function(d) {
	if(d.type == 'person') {
	    if(utils.checkExists(d.id, linksData, 'source') == true) {
		return d
	    }
	} else {
	    return d
	}
    });
}
*/
/*function alphabetise(array) {
    array.sort(function(a, b){
	if(a < b) return -1;
	if(a > b) return 1;
	return 0;
    })
    return array;
}*/
